<div class="order-success text-center py-5">
  <!-- Success Icon -->
  <div class="success-icon mb-5">
    <svg cIcon name="cilCheckCircle" size="5xl" color="success"></svg>
  </div>

  <h2 class="mb-4 text-success">{{ 'order_success_title' | translate }}</h2>

  <!-- Order Details Card -->
  <c-card class="order-details mx-auto shadow-sm" style="max-width: 500px;">
    <c-card-body>
      <p class="mb-4 fs-5">
        {{ 'order_id_label' | translate }}
        <strong class="text-primary">#{{ orderId }}</strong>
      </p>

      @if (isFirstOrder) {
        <c-alert color="success" class="d-flex align-items-center mb-0">
          <svg cIcon name="cilStar" class="me-3" size="lg"></svg>
          <div class="text-start">
            <strong class="d-block mb-1">{{ 'order_first_congratulations' | translate }}</strong>
            <span>{{ 'order_first_message' | translate }}</span>
          </div>
        </c-alert>
      }
    </c-card-body>
  </c-card>

  <!-- Actions -->
  <div class="success-actions mt-5 d-grid gap-3" style="max-width: 400px; margin: 0 auto;">
    <button
      cButton
      color="primary"
      size="lg"
      [routerLink]="dashboardUrl()"
    >
      <svg cIcon name="cilHome" class="me-2"></svg>
      {{ 'order_goto_dashboard' | translate }}
    </button>

    <button
      cButton
      color="secondary"
      variant="outline"
      size="lg"
      (click)="continueShopping()"
    >
      {{ 'order_continue_shopping' | translate }}
    </button>
  </div>
</div>